/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 축제 상세 정보
 * 버전 : 1.0
 * 파일명 : DialogFestival.tsx
 * 작성자 : 강동형
 * 작성일 : 2026-01-19
 * ================================================================
 * 수정일 : 2026-02-03, 삭제기능 임시 연결
 * 수정일 : 2026-02-04, 삭제기능 연결, 데이터 연결
 * 수정일 : 2026-02-05, URL링크 옆으로 늘어지지않고 길어지면 축약되도록 변경
 * ================================================================ */

import { deleteEventInfo } from "src/api/Recruit";
import { AppImage } from "src/assets/images/AppImage";
import { SessionWrapper, toAbsoluteUrl } from "src/utils/Etc"
import styled from "styled-components"
import { LoadFestival } from "./LoadArmyRecruit";
import { useRecruitStore } from "src/stores/RecruitStore";
import { toast } from "react-toastify";
import { parseDateToCommon } from "src/utils/DateUtils";
import { useModalStore } from "src/stores/ModalStore";
import { Common_ModalContent_Simple, Common_ModalFooter_SimpleDouble, Common_ModalTitle_AlertCircle } from "../modals/CommonModal";

const Wrapper = styled.div`
  
`

const DataWrapper = styled.div<{$isFirst?:boolean}>`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    border-top: ${({ $isFirst }) =>$isFirst ? '1px solid #000 ': '1px solid #ededed'};;
    padding: 12px 8px;
    gap: 8px;
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
`

const TitleSpan = styled.span`
  font-size: 20px;
  font-weight: 700;
`

const DateSpan = styled.span`
  font-size: 16px;
  font-weight: 500;
`

const PositionSpan = styled.span`
  font-size: 16px;
  font-weight: 400;
  text-decoration: underline;
`

const ColumnWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const ColumnContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;

  padding: 5px;
  font-size: 14px;
  font-weight: 400;
  text-decoration: underline;
  background-color: #EEF6F8;
  min-width: 0;
  flex: 1;
`

type DialogFestivalProps = {
  dialogData:any
}

const DialogFestival = ({dialogData}:DialogFestivalProps) => {
  const setField = useRecruitStore((state)=>state.setField)
  const year = useRecruitStore((state)=>state.year)
  const month = useRecruitStore((state)=>state.month)
  const dialogState = useRecruitStore((state)=>state.dialogState)
  const modalSetField = useModalStore((state)=>state.setField)
  
  const onClickDelteEventInfo = async (event_id:number)=>{
    try{
      const res = await deleteEventInfo(event_id)

      if(res.status === 'OK'){
        const response = await LoadFestival({year:Number(year),month:Number(month)});
        setField('ArmyRecruitData', response.data);
        setField('isOpen',false)
        modalSetField('open',false)
        toast.success('정상적으로 삭제되었습니다.')
      }
    }
    catch{
      toast.error('삭제 실패')
    }
  }

  const onClickDelete = (event_id:number)=>{
    modalSetField('type','CENTER')
    modalSetField('width','calc(100vw - 20px)')
    modalSetField('padding','20px')
    modalSetField('title',<Common_ModalTitle_AlertCircle title={'정말 삭제하시겠어요?'}/>)
    modalSetField('content',<Common_ModalContent_Simple content="삭제하면 복구할 수 없습니다." customStyle={{textAlign:'center'}}/>)
    modalSetField('footer',<Common_ModalFooter_SimpleDouble
      customWrapperStyle={{width:'100%'}}
      cancleAction={()=>modalSetField('open',false)}
      customCancleStyle={{width:'96px'}}
      confirmAction={()=>onClickDelteEventInfo(event_id)}
      confirmText="삭제"
      customConfirmStyle={{width:'100%'}}
      />)
    modalSetField('open',true)
  }

  const onClickModify = (content:any)=>{
    setField('modifyProps',content)
    setField('dialogState','축제 등록')
  }

  return (
    <Wrapper>
      {dialogData.map((content:any,index:any)=>(
        <DataWrapper $isFirst={index===0}>
          <SessionWrapper session={dialogState==='모집 일정' ? content.course_type : content.recruitment_type}>
            {dialogState==='모집 일정' ? content.course_type : content.recruitment_type}
          </SessionWrapper>
          <TitleWrapper>
            <TitleSpan>{content.title}</TitleSpan>
            <ButtonWrapper>
              <AppImage name='IconNotePadBlack' onClick={()=>onClickModify(content)}/>
              <AppImage name='IconTrash' onClick={()=>onClickDelete(content.announce_id)}/>
            </ButtonWrapper>
          </TitleWrapper>
          <ColumnWrapper>
            <AppImage name='IconCalendarGrey'/>
            <DateSpan>{parseDateToCommon(content.start)} - {parseDateToCommon(content.end)}</DateSpan>
          </ColumnWrapper>
          <ColumnWrapper>
            <AppImage name='IconPosition'/>
            <PositionSpan>{content.address}</PositionSpan>
          </ColumnWrapper>
          <ColumnWrapper>
            <AppImage name='IconGlobal'/>
              {content.urlLink ?
                <ColumnContainer>
                <AppImage name='IconLink' style={{width:'16px',height:'16px'}}/>
                  <a href={toAbsoluteUrl(content.urlLink)} target='_blank' rel='noopener noreferrer' title={content.urlLink}
                    style={{whiteSpace:'nowrap', textOverflow:'ellipsis',flex:1, minWidth:0, overflow:'hidden', textDecoration:'underline', color:'#808089'}}>
                        {content.urlLink}
                  </a>
                </ColumnContainer>
                : '정보없음'}
          </ColumnWrapper>
        </DataWrapper>
      ))}
    </Wrapper>
  )
}

export default DialogFestival